<template>
  <div class="transaction-item" data-testid="transaction-item">
    <div class="transaction-item__course" data-testid="transaction-item-course" @click="goToTransactionDetail">
      <div class="flex gap-4">
        <img :src="transaction.image.url" alt="course-image" height="36" width="36" data-testid="course-image" />
        <div>
          <BlTextAv variation="caption-12" :ellipsis="1" data-testid="course-name">{{ transaction.name }}</BlTextAv>
          <BlTextAv variation="body-14" weight="bold" class="mt-4" data-testid="course-price">{{ transaction.price | money }}</BlTextAv>
        </div>
      </div>
      <IcoChevronRightMinor />
    </div>
    <BlSeparatorAv class="mv-8" />
    <div>
      <BlTextAv variation="caption-12" color="subdued" class="mb-8">Checklist</BlTextAv>
      <div
        v-for="(data, idx) in timelineList"
        :key="idx"
        class="transaction-item__timeline-container"
        :class="idx + 1 !== timelineList.length && 'transaction-item__timeline-container-active'"
        :data-testid="'timeline-item-' + idx"
      >
        <BlCheckboxAv v-model="data.active" class="checklist-item" :native-value="true" />
        <BlTextAv variation="body-14">{{ data.text }}</BlTextAv>
      </div>
    </div>
  </div>
</template>

<script>
import {BlTextAv, BlSeparatorAv, BlCheckboxAv} from '@bukalapak/bazaar-mweb-latest';
import {money} from '@bukalapak/toolbox-helper/number-helper';
import {IcoChevronRightMinor} from '@bukalapak/bazaar-visual-next';

export default {
  name: 'TransactionCardItem',
  components: {
    BlTextAv,
    IcoChevronRightMinor,
    BlSeparatorAv,
    BlCheckboxAv,
  },
  filters: {money},
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    transactionUrl() {
      return `/transaksi/${this.transaction.deal_transaction_id}`;
    },
    timelineList() {
      let timeline = [
        {
          text: 'Beli kelas',
          active: true,
        },
        {
          text: 'Redeem Kelas',
          active: false,
        },
        {
          text: 'Ikuti dan selesaikan kelas',
          active: false,
        },
      ];
      if (this.transaction.state === 'redeemed' || this.transaction.state === 'completed') timeline[1].active = true;
      if (this.transaction.state === 'completed') timeline[2].active = true;
      return timeline;
    },
  },
  methods: {
    goToTransactionDetail() {
      this.$router.push(this.transactionUrl);
    },
  },
};
</script>
<style lang="scss" scoped>
.transaction-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px 12px;
  background: #ffffff;
  .transaction-item__course {
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      border-radius: 8px;
      object-fit: cover;
    }
  }
  &__timeline-container {
    position: relative;
    padding-left: 28px;
    padding-bottom: 12px;
  }
  &__timeline-container-active {
    &:before {
      position: absolute;
      width: 2px;
      height: 100%;
      background-color: #d3dae5;
      top: 6px;
      left: 11px;
      margin: auto;
      content: '';
    }
  }
  .checklist-item {
    pointer-events: none;
    position: absolute;
    top: 2px;
    left: 0;
    z-index: 1;
    height: 12px;
    width: 12px;
    margin: auto;
    &::v-deep {
      .bl-checkbox__check {
        border-radius: 100px;
      }
    }
  }
}
</style>
